import React from 'react';
import { Flex, Icon, Text } from '@chakra-ui/react';

const InfoRow = ({ label, value, icon }) => (
  <Flex
    alignItems="center"
    border="1px"
    borderColor="gray.300"
    borderRadius="md"
    p={2}
  >
    {icon && (
      <Icon as={icon} boxSize={5} color="gray.400" mr={2} />
    )}
    <Text fontWeight="500" color="gray.500" fontSize="sm" mr={2}>
      {label}:
    </Text>
    <Text fontSize="sm">{value || 'N/A'}</Text>
  </Flex>
);

export default InfoRow;
